/**
 * Lines — renders a label that carries its own line breaks.
 *
 * A menu label is DATA: it comes from the CMS or from i18n, and the enquiry
 * label is deliberately two lines ("Enquiry" / "and Pricing"). Splitting it
 * here — rather than leaning on a `whitespace-pre-line` rule at each call
 * site — keeps the break working everywhere the label is rendered, including
 * inside links that carry `whitespace-nowrap` (the desktop nav does), where a
 * newline would otherwise collapse back into a space.
 *
 * A label without a break renders as plain text, so the common case costs
 * nothing and no extra element appears in the DOM.
 *
 * Use `oneLine()` (src/utils/seoText.ts) for the same label where a line
 * break has no meaning — JSON-LD names, <title>, meta tags.
 */
export default function Lines({ text, className }: { text: string; className?: string }) {
  if (!text.includes('\n')) return <>{text}</>
  return <span className={`whitespace-pre-line ${className ?? ''}`}>{text}</span>
}
